// src/services/revisorService.js
import api from '../services/api';

export const listarRevisores = async () => {
    return api.get('/revisores');
};

export const obterRevisor = async (id) => {
    return api.get(`/revisores/${id}`);
};

export const criarRevisor = async (revisor) => {
    return api.post('/revisores', revisor);
};

export const atualizarRevisor = async (id, revisor) => {
    return api.put(`/revisores/${id}`, revisor);
};

export const excluirRevisor = async (id) => {
    return api.delete(`/revisores/${id}`);
};